// ── Persona taxonomy (mirror of server/personas.js) ────────────────────────────
// Keep in sync with hobbyconnect/server/personas.js and mobile/src/personas.js.

export const PERSONAS = [
  { id: 'grehini_chef',    label: 'Grehini — Master Chef', emoji: '👩‍🍳', group: 'grehini' },
  { id: 'driver',          label: 'Driver',                emoji: '🚗', group: 'grehini' },
  { id: 'tuition_teacher', label: 'Tuitions Teacher',      emoji: '📚', group: 'grehini' },
  { id: 'sports_teacher',  label: 'Sports Teacher',        emoji: '🏅', group: 'grehini' },
  { id: 'hobby_classes',   label: 'Hobby Classes',         emoji: '🎨', group: 'grehini',
    examples: ['Crochet', 'Oil painting', 'Mirror art', 'Lippan art', 'Embroidery', 'Cooking classes', 'Baking classes'] },
  { id: 'expert_group',    label: 'Expert Group',          emoji: '🏆', group: 'expert',
    examples: ['Chess', 'Badminton', 'Lawn tennis', 'Robotics', 'Piano', 'Flute', 'Singing', 'Bhajan'] },
  { id: 'shopathome',      label: 'Shop at Home',          emoji: '🛍️', group: 'shopathome',
    examples: ['Cake', 'Pastry', 'Toys', 'Rakhi', 'Gift items', 'Bedsheets', 'Kurtas', 'Dress materials'] },
  { id: 'bhajan_mandali',  label: 'Bhajan Mandali',        emoji: '🕉️', group: 'organiser' },
  { id: 'kitty_organiser', label: 'Kitty Organiser',       emoji: '🎉', group: 'organiser',
    examples: ['Games', 'Food', 'Gifts', 'Kitty themes & ideas'] },
  { id: 'event_organiser', label: 'Event Organiser',       emoji: '🎪', group: 'organiser' },
  { id: 'cultural_organiser', label: 'Cultural Event Organiser', emoji: '🎭', group: 'organiser',
    examples: ['Ganesh Chaturthi', 'Navratri / Garba', 'Diwali mela', 'Holi', 'Eid', 'Christmas',
               'Society annual day', 'Independence Day', 'Talent show', 'Cultural night'] },
  { id: 'shoot_reel',      label: 'Shoot & Reel',          emoji: '🎬', group: 'media' },
  { id: 'travel',          label: 'Travel & Trips',        emoji: '✈️', group: 'travel',
    examples: ['Weekend getaways', 'Road trips', 'Backpacking', 'Treks', 'Group tours'] },
];

// Broad namespaced categories — shown as `hobbyorigin/<slug>` (mirror of server/personas.js).
export const BROAD_CATEGORIES = [
  { id: 'food',    slug: 'food',    label: 'Food',          emoji: '🍲' },
  { id: 'tutor',   slug: 'tutor',   label: 'Tutor',         emoji: '📚' },
  { id: 'sports',  slug: 'sports',  label: 'Sports',        emoji: '🏅' },
  { id: 'classes', slug: 'classes', label: 'Hobby Classes', emoji: '🎨' },
  { id: 'expert',  slug: 'expert',  label: 'Expert Groups', emoji: '🏆' },
  { id: 'shop',    slug: 'shop',    label: 'Shop',          emoji: '🛍️' },
  { id: 'events',  slug: 'events',  label: 'Events',        emoji: '🎪' },
  { id: 'culture', slug: 'culture', label: 'Cultural Events', emoji: '🎭' },
  { id: 'bhajan',  slug: 'bhajan',  label: 'Bhajan',        emoji: '🕉️' },
  { id: 'media',   slug: 'media',   label: 'Shoot & Reel',  emoji: '🎬' },
];
export function broadCategoryById(id) {
  return BROAD_CATEGORIES.find(b => b.id === id) || null;
}
// `hobbyorigin/food` style label.
export function broadCategoryPath(id) {
  const b = broadCategoryById(id);
  return b ? `hobbyorigin/${b.slug}` : '';
}

export const PERSONA_GROUPS = {
  grehini: 'Grehini & Home Services',
  expert: 'Expert Groups',
  shopathome: 'Shop at Home',
  organiser: 'Organisers & Community',
  media: 'Media',
  travel: 'Travel & Adventure',
};

export function personaById(id) {
  return PERSONAS.find(p => p.id === id) || null;
}

// "🎂 Grehini — Master Chef" style label for a persona id (falls back to '').
export function personaLabel(id) {
  const p = personaById(id);
  return p ? `${p.emoji} ${p.label}` : '';
}
